import React, { useState } from "react";
import { CheckCircleIcon as CheckCircleIconSolid } from "@heroicons/react/solid";
import { updateMPSBusinessProfile } from "../../../firebaseFunctions/updateMPSBusinessProfile/updateMPSBusinessProfile";

const ModalMPSSaveChangesSuccess = ({ handleClose, handleContinue, mpsEventRegistrationInfo, mpsUserId, setIsLoading }) => {
  const [updateChangesToMPSProfile, setUpdateChangesToMPSProfile] = useState(false);

  const updatedMPSProfileObject = {
    businessName: mpsEventRegistrationInfo?.businessName || "",
    companyLogo: mpsEventRegistrationInfo?.companyLogo || "",
    description: mpsEventRegistrationInfo?.businessDescription || "",
    email: mpsEventRegistrationInfo?.businessEmail || "",
    phoneNumber: mpsEventRegistrationInfo?.businessPhoneNumber || "",
    typeOfBusiness: mpsEventRegistrationInfo?.businessType || "",
    website: mpsEventRegistrationInfo?.businessWebsite || "",
    socialMediaLinks: mpsEventRegistrationInfo?.businessSocialProfiles || [],
    businessDocuments: mpsEventRegistrationInfo?.businessDocuments || [],
    businessDescription: mpsEventRegistrationInfo?.businessDescription,
  };

  const handleCheckboxChange = () => {
    setUpdateChangesToMPSProfile(!updateChangesToMPSProfile);
  };
  const handleContinueWithUpdate = async () => {
    setIsLoading(true);
    try {
      if (updateChangesToMPSProfile) {
        const response = await updateMPSBusinessProfile(mpsUserId, updatedMPSProfileObject);
        if (!response.success) {
          throw new Error(response.message || "Update failed");
        }
      }
      handleClose();
      handleContinue();
    } catch (error) {
      console.error("Error in updating MPS Business Profile:", error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-opacity-100 bg-grey-25">
      <div className="justify-center w-full max-w-md p-6 bg-white shadow-lg rounded-2xl">
        <div className="flex justify-center space-x-4">
          <CheckCircleIconSolid className="size-20 text-Success/700" />
        </div>
        <h2 className="justify-center mt-4 mb-6 text-lg font-semibold text-center text-grey-900">
          Your changes have saved!
        </h2>
        <p className="mb-6 text-sm text-center text-grey-600">
          {`Do you want to update your profile with these changes?`}
        </p>
        <div className="flex items-center pl-4 mb-4 space-x-2">
          <input
            type="checkbox"
            id="selectAll"
            checked={updateChangesToMPSProfile}
            onChange={handleCheckboxChange}
            className="w-4 h-4 rounded border-grey-300"
          />
          <label htmlFor="selectAll" className="text-xs text-grey-900">
            <span className="text-sm text-grey-900">
              Yes, update these changes to my profile
            </span>
          </label>
        </div>
        <div className="flex justify-center space-x-4">
          <button
            className={`px-4 py-3 text-base font-semibold rounded-lg ${updateChangesToMPSProfile
              ? "bg-grey-700 hover:bg-grey-800 text-grey-25"
              : "bg-grey-300 text-grey-600 cursor-not-allowed"
              }`}
            onClick={handleContinueWithUpdate}
            disabled={!updateChangesToMPSProfile}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalMPSSaveChangesSuccess;